var api = "https://api.qingcigame.com";
var activeKey = 'b5a767b706ac979e159a044e7b20a8a1';
const config = {
  account: "",
  channel: "",
  id: "",
  platform: "",
  area: "",
  game_id:74,
  role_id: "",
  page_id: 11
};
let bindParams = {};
let timer = null;
let wait = 60;

var initialSlide = 0; //设置默认索引为0

var shareText = '';
shareText = [
  '珍绮华筵，蝶舞翩跹。首款Clamp杂志款小小樱限时发售中，点击链接查看',
  '与我一起前往宝石之境，携手梦幻小小樱开启神秘国度之旅。点击链接前往',
  '《魔卡少女樱：回忆钥匙》满月庆典现已开启！首款梦幻小小樱限时发售中，快来参与庆典吧！'
][Math.floor(Math.random() * 3)];

var requestInterface =  {};
var routerParams = {};
var awardNum = 0; // 可以领取的奖励数量
var gameNum = 0; // 游戏次数
var isBindRole = false;
var product1, product2, product3, product4, product5;
var obj = {
    index: function() {
        // this.mouseEffect(); // 鼠标效果
        this.preloading(); // 预加载
        this.indexBind(); // 首页按钮
        this.share(); // 分享
        this.clipboardInfo(); // 复制
        this.onInit();
        routerParams = analysisParams(window.location.href);
        if (routerParams.helper_id) {
          requestInterface.share({helper_id: routerParams.helper_id});
        }
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".process-track .process-inner").width(parseInt(e.progress * 100) + '%');
                $(".process-percent #percent").html(parseInt(e.progress * 100));
            };
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.index').addClass('index-show');
            this.indexSwiper();
            $('#preloading').fadeOut();
            setTimeout(function() {
                $('#preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的            
            '/card-pool/images/pc/preloading_bg-c7263a25f5.png',
            '/card-pool/images/pc/content_bg-c7bffd9728.png',
            '/card-pool/images/pc/content_bg2-c7263a25f5.png',
            '/card-pool/images/pc/index_bg-165a32d861.png',
            '/card-pool/images/pc/home_title-4b2064ccab.png',
            '/card-pool/images/pc/header_logo-c3e54f24ff.png',
            '/card-pool/images/pc/icon_s-1fd4501ffe.png',
            '/card-pool/images/pc/download_btn-b8ead72102.png',
            '/card-pool/images/pc/header_bg-606e0aaa4a.png',
        ]);
    },
    // 首页轮播
    indexSwiper: function() {
        var mySwiper = new Swiper('.swiper-container', {
            pagination: '.swiper-pagination',
            direction: 'vertical',
            slidesPerView: 'auto',
            paginationClickable: true,
            spaceBetween: 0,
            mousewheel: true,
            resistanceRatio: 0,
            initialSlide: initialSlide,
            touchStartForcePreventDefault: true,
            paginationClickable: true,
            parallax: true,
            on: {
                init: function() {
                    swiperAnimate(this);
                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            mySwiper.slideTo(page, 1000, true);
                        });
                    };
                    function navLink() {
                        for (var i = 4; i >= 0; i--) {
                            Ani('.nav-link-0' + i + ' .link-a', i);
                        };
                    }
                    navLink();
                    var aniLink01 = Ani('.arrow-b', '1');
                    var aniLink02 = Ani('.arrow-b2', '2');
                    var aniLink03 = Ani('.arrow-b3', '3');
                },
                transitionStart: function() {
                    swiperAnimate(this);
                    $('.nav-link').removeClass('on')
                    $('.nav-link-0' + this.activeIndex + '').addClass('on');
                },
            },
        });

        var charitySwiper = new Swiper('.swiper-container-feature', {
            loop: true,
            paginationClickable: true,
            pagination: {
                el: '.swiper-pagination4',
                clickable: true,
            },
            noSwiping: true,
            autoplayDisableOnInteraction: false,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            effect: 'coverflow',
            centeredSlides: true,
            slidesPerView: 'auto',
            loopedSlides: '5',
            observer: true,
            observerParents: true,
            speed: 500,
            coverflowEffect: {
                rotate: 0, // 旋转的角度
                stretch: 40, // 拉伸   图片间左右的间距和密集度
                depth: 20, // 深度   切换图片间上下的间距和密集度
                modifier: 31.5, // 修正值 该值越大前面的效果越明显
                slideShadows: false // 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(this);
                swiper.stopAutoplay();
            },
        });
        
        // 小小樱角色轮播
        // obj.roleSwiper();
        obj.ThreeSixtyJs();
    },
    roleSwiper: function() {
        function t(t, a, s) {
            var n = 1 * s.attr("data-index");
            if (! (13 > n - d && n - d > 2 || n - d > -13 && -2 > n - d)) {
                d = n,
                h = n,
                t = parseInt(t),
                a = parseInt(a);
                var p = Math.abs(t - a),
                f = 0;
                3 > p ? f = t > a ? c + p * i: c - p * i: a > 2 && 4 > t ? f = c + (5 - p) * i: 4 > a && t > 2 && (f = c - (5 - p) * i),
                o.css("transform", "rotate(" + -f + "deg)"),
                e.css("transform", "rotate(" + f + "deg)"),
                r = a,
                c = f,
                v.slideTo(r, 1e3, !1),
                o.removeClass("active"),
                s.addClass("active"),
                s.siblings().css("opacity", 0),
                "0" == s.attr("data-index") ? (o.eq( - 1).css("opacity", 1), o.eq( - 2).css("opacity", 1)) : "1" == s.attr("data-index") ? o.eq( - 1).css("opacity", 1) : "14" == s.attr("data-index") ? (o.eq(0).css("opacity", 1), o.eq(1).css("opacity", 1)) : "13" == s.attr("data-index") && o.eq(0).css("opacity", 1),
                s.css("opacity", 1),
                s.prev().css("opacity", 1),
                s.prev().prev().css("opacity", 1),
                s.next().css("opacity", 1),
                s.next().next().css("opacity", 1)
            }
        }
        function a() {
            p = setInterval(function() {
                var a = void 0;
                0 > h - 1 ? h = 14 : h -= 1,
                a = 0 > r - 1 ? 4 : r - 1,
                t(r, a, o.eq(h))
            },
            5e3)
            s();
        }
        function s() {
            clearInterval(p)
        }
        var e = $(".char-pagi-container"),
        i = 24,
        c = 0,
        r = 0,
        n = void 0,
        o = $(".char-pagi"),
        d = 0,
        h = 0,
        p = null,
        v = new Swiper("#js_char_swiper", {
            speed: 500,
            effect: "fade",
            fadeEffect: {
                crossFade: !0
            },
            simulateTouch: !1
        }),
        f = e.width();
        n = f / 2.5;
        var l = e.height(),
        u = Math.PI,
        y = 2 * Math.PI / o.length;
        o.each(function() {
            var t = Math.round(f / 2 + n * Math.cos(u) - $(this).width() / 2),
            a = Math.round(l / 2 + n * Math.sin(u) - $(this).height() / 2);
            $(this).css({
                left: t + "px",
                top: a + "px"
            }),
            u += y
        }),
        o.click(function() {
            var a = $(this),
            e = $(this).attr("data-char-index");
            s(),
            t(r, e, a)
        }),
        t(0, r, o.eq(h)),
        a()
    },    
    // 首页按钮
    indexBind: function() {
        // 登陆相关绑定事件
        obj.loginEventBind();

        $('.award_list_btn').on('click', function() {
          $('.award_list_popup').fadeIn();
        });

        // $('.wx-btn').on('click', function() {
        //   $('.wechat_popup').fadeIn();
        // });
        $('.wechat_popup .confirm_btn').on('click', function() {
          $('.wechat_popup').fadeOut();
        });

        $('.jump_btn').on('click', function() {
          const href = $(this).data('href');
          const eventName = $(this).data('event');
          if (eventName) {
            requestInterface.countNum(eventName);
          }
          if (href) {
            window.location.href = href;
          }
        });

        $('.prize_btn').on('click', function() {
          if (!config.account) {
            layer.msg("请先登录");
            return false;
          }
          $('.my_prize_popup').fadeIn();
          requestInterface.countNum('我的奖品按钮');
        });

        $('.share_btn').on('click', function() {
            if (!config.account) {
              layer.msg("请先登录");
              return false;
            }
            $('.share_popup').fadeIn();
            requestInterface.countNum('前往分享');
        });

        $('.award_list_box .confirm_btn').on('click', function() {
          $('.award_list_popup').fadeOut();
        });
        
        $('.my_prize .receive_btn').on('click', function() {
          if (awardNum === 0) {
            layer.msg("没有能领取的奖品，快去祈愿吧");
            return false;
          }
          // 打开弹窗
          if (isBindRole) { // 已经绑定角色，提示奖励领取到哪个角色
            $('.reward_popup').fadeIn();
          } else { // 未绑定的让玩家绑定角色
            obj.serverInfo(config.account);
          }
          requestInterface.countNum('一键领取');
        });
        // 抽奖按钮
        $('.lottery_btn').on('click', function() {
            $('.prevent-wrap').show();
            requestInterface.lottery({}, function(response) {
              if (response.code == 200) {
                const { prize_id, title, is_prize } = response.data;
                if (is_prize == 0) {
                  $('.un_award_popup').fadeIn();
                } else {
                  $('.prize_popup .prop').attr('class', `prop prop_${prize_id}`);
                  $('.prize_popup .prop_name').text(title);
                  $('.prize_popup').fadeIn();
                }
              }
            });
            requestInterface.countNum('抽奖按钮');
        });

        // 关闭弹窗 且初始化
        $('.prize_popup .confirm_btn, .un_award_popup .confirm_btn').on('click', function() {
          $('.prize_popup, .un_award_popup').fadeOut();
          obj.onInit();
        });

        // 确认领奖
        $('.bind_confirm_popup .confirm_btn, .reward_popup .confirm_btn').on('click', function() {
          requestInterface.reward({...bindParams}, function() {
            $('.my_prize_popup').fadeOut();
            $('.reward_popup').fadeOut();
            $('.bind_confirm_popup').fadeOut();
            layer.msg("领取成功", { time: 2000 });
            obj.onInit();
          });
        });
        // 确认绑定-返回
        $('.bind_confirm_popup .return_btn').on('click', function() {
          bindParams = {};
          $('.bind_confirm_popup').fadeOut();
          obj.serverInfo(config.account);
        });
        $('.close_bind').on('click', function() {
          $('.bind_confirm_popup').fadeOut();
        });
        $('.close_reward').on('click', function() {
          $('.reward_popup').fadeOut();
        });

        // 奖池列表
        $('.reward-list-btn').click(function() {
            $('.jackpot-wrap').fadeIn();
            requestInterface.countNum('奖池列表');
        })

        // 规则
        $('.rule-btn').click(function() {
            $('.rule-wrap').fadeIn();
            requestInterface.countNum('规则按钮');
        })

        // 关闭弹窗
        $('.close-btn, .close-bg').click(function() {
            $('.popup_wrap').fadeOut();
        })

        // 角色CG图
        $('.name').on('click','a',function(){
            var _data = $(this).attr('data');
            var _imgData = $(this).attr('imgData');
            $('.cg-wrap').fadeIn()
            $('.cg-box').addClass('cg-'+_data+'').find('img').attr('src', _imgData);
            requestInterface.countNum('打开CG弹窗');
        })
        $('.cg-wrap').on('click','.close-btn',function(){
          setTimeout(() => {
            for (var i = 5; i >= 1; i--) { $('.cg-box').removeClass('cg-'+i+'')};
          }, 500);            
        })
    },
    ThreeSixtyJs: function() {
        $('.role-1').click(function(event) {
            $('.threesixty-1').fadeIn().siblings('.threesixty').fadeOut();
        });
        $('.role-2').click(function(event) {
            $('.threesixty-2').fadeIn().siblings('.threesixty').fadeOut();
        });
        $('.role-3').click(function(event) {
            $('.threesixty-3').fadeIn().siblings('.threesixty').fadeOut();
        });
        $('.role-4').click(function(event) {
            $('.threesixty-4').fadeIn().siblings('.threesixty').fadeOut();
        });
        $('.role-5').click(function(event) {
            $('.threesixty-5').fadeIn().siblings('.threesixty').fadeOut();
        });

        function productInfo() {
            $('.threesixty .threesixty_images').html('');
            product1 = $('.threesixty-1').ThreeSixty({
                totalFrames: 81,
                endFrame: 12,
                currentFrame: 5,    
                imgList: '.threesixty_images-1',
                progress: '.spinner-1',
                imagePath: 'card-pool/1/',
                filePrefix: '',
                ext: '.webp',
                width: 648,
                height: 1152,
                navigation: false,
                disableSpin: false
            });
            product2 = $('.threesixty-2').ThreeSixty({
                totalFrames: 81,
                endFrame: 1,
                currentFrame: 5,    
                imgList: '.threesixty_images-2',
                progress: '.spinner-2',
                imagePath: 'card-pool/4/',
                filePrefix: '',
                ext: '.webp',
                width: 648,
                height: 1152,
                navigation: false,
                disableSpin: false
            });
            product3 = $('.threesixty-3').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,    
                imgList: '.threesixty_images-3',
                progress: '.spinner-3',
                imagePath: 'card-pool/3/',
                filePrefix: '',
                ext: '.webp',
                width: 648,
                height: 1152,
                navigation: false,
                disableSpin: false
            });
            product4 = $('.threesixty-4').ThreeSixty({
                totalFrames: 81,
                endFrame: 1,
                currentFrame: 5,    
                imgList: '.threesixty_images-4',
                progress: '.spinner-4',
                imagePath: 'card-pool/2/',
                filePrefix: '',
                ext: '.webp',
                width: 648,
                height: 1152,
                navigation: false,
                disableSpin: false
            });
            product5 = $('.threesixty-5').ThreeSixty({
                totalFrames: 80,
                endFrame: 1,
                currentFrame: 5,    
                imgList: '.threesixty_images-5',
                progress: '.spinner-5',
                imagePath: 'card-pool/5/',
                filePrefix: '',
                ext: '.webp',
                width: 648,
                height: 1152,
                navigation: false,
                disableSpin: false
            });
            $('.threesixty-5').fadeIn();
            $('.char-pagi-container .role-5').click();
        }productInfo();        
    },
    // 鼠标效果
    mouseEffect: function() {
        const stack = [];
        thisMousemove();
        function thisMousemove() {
            document.addEventListener('mousemove', function(e) {
                if (stack.length > 40) {
                  stack[0] && stack[0].remove();
                  stack.shift();
                }
                let body = document.querySelector('body');
                let heart = document.createElement('i');
                let x = e.clientX;
                let y = e.clientY;
                heart.style.left = x + 'px';
                heart.style.top = y + 'px';
            
                let size = Math.random() * 1;
                heart.style.width = 15 + size + 'px';
                heart.style.height = 15 + size + 'px';
            
                let transformValue = Math.random() * 360;
                heart.style.transform = `rotate(${transformValue}deg)`;
                stack.push(heart);
                body.appendChild(heart);
            
                setTimeout(() => {
                  heart && heart.remove();
                }, 500)
            })
        }
        
    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(this).height();
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 微信分享
    share: function() {
        var share_icon = 'https://download4.qcplay.com/qcgame-admin/dnX29EuzSenmU1Vt8cDJvCOGHofjdxkHtEs0Lzhm.png'
        var share_big_title = '魔卡少女樱：回忆钥匙';
        var share_min_title = '收集全世界的可爱';
        outside.share(share_icon, share_big_title, share_min_title);
    },
    clipboardInfo: function() {
        var codeClipboard = new Clipboard(document.querySelector(".copy_link_btn"));
            codeClipboard.on("success", function (e) {
            layer.msg("已复制至剪贴板，快分享给好友吧~");
            requestInterface.countNum('复制链接');
        return;
        });
            codeClipboard.on("error", function (e) {
            console.error("Action:", e.action);
            console.error("Trigger:", e.trigger);
        });
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    },
    // 初始化用户信息
  onInit: function() {
    return;
    requestInterface.init({}, function(response) {
      const { data } = response;
      if (response.code == 200) {
        const { user_info, activity } = data;
        config.account = user_info.account;
        obj.updateHeader();
        // 更新我的奖池
        const rewardList = activity.reward_list;
        let rewardHtml = '';
        awardNum = 0;
        gameNum = activity.times;
        isBindRole = activity.is_bind == 1;
        if (isBindRole) {
          const { role_id, role_name, server_id, server_name, platform } = activity;
          bindParams = { role_id, role_name, server_id, server_name, platform };
          $('.prompt-title').fadeIn();
          $('.reward_popup .reward_box p span').text(`${role_name}(${server_name})`);
        } else {
          bindParams = {};
        }
        if (activity.notice) {
          const { account, title } = activity.notice;
          $('.winner_box .role_name').text(account);
          $('.winner_box .award_name').text(title);
          $('.winner_box').show();
        } else {
          $('.winner_box').hide();
        }
        rewardList.forEach((item) => {
          if (item.is_send === 0) {
            awardNum ++;
          }
          rewardHtml += `<li class="${item.is_send === 1 ? 'reward' : ''}"><p><span>${item.remark}</span></p></li>`;
        });

        if (rewardList.length > 5) {
          $('.my_prize_popup .more_icon').show();
        } else {
          $('.my_prize_popup .more_icon').hide();
        }

        $('.my_prize_popup .list ul').html(rewardHtml);
        $('.content-02 .operation .number span').text(activity.times);
        $('.copy_link_btn').attr('data-clipboard-text', `${shareText}https://sakura.qingcijoy.com/card-pool/index_mobile.html?helper_id=${activity.user_id}`);
      } else {
        // obj.openLoginPopup();
      }
    });
  },
  // 打开登陆弹窗
  openLoginPopup: function() {
    $('.inp-account').val('');
    $('.inp-password').val('');
    $('.phone-inp').val('');
    $('input[name=sms_code]').val('');
    $('.inp-role-name').val('');
    $('.inp-role-id').val('');
    clearTimeout(timer);
    wait = 60;
    setTimeout(() => {
        $('.obtain-verification label span a').remove();
        $('.obtain-verification label span').html("<a>发送</a>");
    }, 100);
    $('.register-popup').fadeIn();
  },
  // 登陆弹窗相关事件绑定
  loginEventBind: function() {
    // 切换登陆方式
    $('.register-box .title').on('click', 'div', function(event) {
      $(this).addClass('active').siblings().removeClass('active');
      for (var i = 0; i <= 2; i++) {
        $('.form-main').removeClass('move-'+i+'')
      };
      $('.form-main').addClass('move-'+$(this).attr('data')+'')
    });
    // 登陆弹窗关闭按钮
    $('.register-popup .close-bg').on('click', function() {
      $('.register-popup').fadeOut();
    });
    // 光子服/正式服 切换
    $('.tab-server').on('click', 'div', function(event) {
      $(this).addClass('active').siblings().removeClass('active')
        .parent('.tab-server').siblings('.option-main')
        .children('.option-box').eq($(this).index())
        .addClass('show').siblings().removeClass('show');

      $('.gzf select').val('0')
      $('.gzf input[name=gzf_role_name]').val('')
      $('.zsf-os').val('')
      $('.zsf-server').val('')
      $('.zsf input[name=zsf_role_name]').val('');

      bindParams = {
        game_id: $(this).parent().find('.active').attr('data-game-id'),
        role_id: "",
        role_name: "",
        server_id: "",
        server_name: "",
        type: ""
      };
    });

    // 账户登陆
    $('.register-btn').click(function(event) {
      const account = $('.inp-account').val();
      const password = $('.inp-password').val();
      if (account == '') {
        layer.msg("请输入您的账号", { time: 2000 });
        return false;
      }
      if (password == '') {
          layer.msg("请输入您的密码", { time: 2000 });
          return false;
      }
      requestInterface.accountLogin(
        {account, password, is_remember: 1}, function(response) {
          localStorage.setItem('access_token', response.data.access_token);
          $('.popup').fadeOut();
          obj.onInit();
        });
    });
    // 验证码登陆
    $('.sms-login').click(function() {
      const account = $('.phone-inp').val();
      const code = $('input[name=sms_code]').val();

      if (account == '') {
        layer.msg("请输入正确的手机号", { time: 2000 });
        return false;
      }
      if (!code) {
        layer.msg("请输入您的验证码", { time: 2000 });
        return false;
      }

      requestInterface.smsLogin(
        {account, sms_code: code, is_remember: 1}, function(response) {
          localStorage.setItem('access_token', response.data.access_token);
          $('.popup').fadeOut();
          obj.onInit();
        });
    });

    // 验证码发送
    $('.obtain-verification').on('click', 'a', function(event) {
      const phone = $('.phone-inp');
      if (!phone.val()) {
          layer.msg("请输入手机号", { time: 2000 });
          phone.focus();
          return false;
      }
      requestInterface.sendSms(phone.val());
    });

    // 绑定角色
    $('.confirm-btn').click(function(event) {
      console.log(bindParams);
      if (bindParams.role_id == undefined) {
        layer.msg("请先选择信息");
        return false;
      }
      // TODO: 二次确认弹窗
      $('.bind_confirm_popup .bind_confirm_box p span').text(`${bindParams.role_name}(${bindParams.server_name})`);
      $('.server-popup').fadeOut();
      $('.bind_confirm_popup').fadeIn();
    });
    $('.cancell-btn').on('click', function() {
      $('.server-popup').fadeOut();
    });

    $('.channel-cancell-btn').click(function(event) {
      obj.onLogout();
    });

    // 头部点击
    $('.header .login_btn').on('click', function() {
      obj.openLoginPopup();
      requestInterface.countNum('登陆按钮');
    });
    $('.header .logout_btn').on('click', function() {
      $('.logout-popup').fadeIn();
      requestInterface.countNum('注销按钮');
    });
    $('.logout-popup .close-bg').on('click', function() {
      $('.logout-popup').fadeOut();
    });
  },
  serverInfo: function(account) {
    // 初始化打开状态
    $('.tab-server').show();
    $('.tab-server').find('.active').removeClass('active');
    $('.tab-server').find('div:first').addClass('active');
    $('.gzf').addClass('show');
    $('.zsf').removeClass('show');
    $('input[name=gzf_role_name]').val('');
    $('input[name=zsf_role_name]').val('');

    // 初始化参数状态
    bindParams = {};

    requestInterface.getRoleList({account: account, app_id: 74, page_id: config.page_id}, function(json) {
      var xff = json.data[61], zsf = json.data[74];
      if (!xff && !zsf) {
        layer.msg("查无您的角色信息")
        return false;
      } else if (!xff || !zsf) {
        $('.tab-server').hide();
      } else {
        $('.tab-server').show();
      }

      if (xff) {
        $('.gzf select').html('<option value="0">请选择区组</option>');
        var list = xff.android;
        for (var key in list) {
          var value = list[key];
          const jsonExtra = JSON.stringify(value['extra'])
          $('.gzf select').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id']  + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] +'</option>')
        }

        $('.gzf select').off('change').on('change', function() {
          var option = $(this).find('option:selected');
          console.log('option', option.val());
          if (option.val() && option.val() != '0') {
            // 改值
            $('input[name=gzf_role_name]').val($(this).find('option:selected').attr('data-role-name'));
            bindParams = {
              game_id: 61,
              role_id: option.attr('data-role_id'),
              role_name: option.attr('data-role-name'),
              server_id: option.attr('data-serverId'),
              server_name: option.attr('data-server_name'),
              type: "android",
              platform: option.attr('data-platform'),
              extra: option.attr('data-extra')
            }
          } else {
            // 清空
            $('input[name=gzf_role_name]').val('');
            bindParams = {}
          }
        });
      } else {
        $('.gzf').removeClass('show');
      }

      if (zsf) {
        // 如果没有光子服就显示
        xff ? $('.zsf').removeClass('show') : $('.zsf').addClass('show');

        $('.zsf-server').html('<option value="">请选择区服</option>')
          // 初始化内容
          $('.zsf-os').html('<option value="">请选择手机系统</option>')
            
          // 拼接手机系统
          for (var key in zsf) {
            $('.zsf-os').append('<option value="' + key + '">ios/安卓</option>')  
          }

          // 手机系统选择
          $('.zsf-os').off('change').on('change', function() {
            bindParams = { game_id: 74, type: $(this).val() };
            var role = zsf[$(this).val()];
            // 区服下拉框设置为空
            $('.zsf-server').html('<option value="">请选择区服</option>');
            // 角色信息为空
            $('.zsf-role').val('');
            // 拼接区服下拉框
            for (var key in role) {
                var value = role[key];
                const jsonExtra = JSON.stringify(value['extra'])
                console.log(jsonExtra)
                $('.zsf-server').append('<option data-role_id="' + value['role_id'] + '" data-role-name="' + value['role_name'] + '" data-serverId="' + value['server_id'] + '" data-platform="' + value['platform'] + '" data-extra=' + jsonExtra + ' data-server_name="' + value['server_name'] + '">' + value['server_name'] + '</option>')
            }

            // 响应区服下拉框事件
            $('.zsf-server').on('change', function() {
              var option = $(this).find('option:selected');
              if (option.val()) {
                $('.zsf-role').val(option.attr('data-role-name'))
                bindParams.role_id = option.attr('data-role_id')
                bindParams.role_name = option.attr('data-role-name')
                bindParams.server_id = option.attr('data-serverId')
                bindParams.server_name = option.attr('data-server_name')
                bindParams.platform = option.attr('data-platform'),
                bindParams.extra = option.attr('data-extra')
              } else {
                $('.zsf-role').val('');
                bindParams = { game_id: 74, type: $(this).val() }
              }
            });
          });
      } else {
        $('.zsf').removeClass('show');
      }

      $('.inp-account').val(''); // 账号密码清空
      $('.inp-password').val(''); // 账号密码清空
      $('.register-popup').fadeOut(); // 关闭登陆页面
      $('.server-popup').fadeIn(); // 开启服务器
    });
  },
  updateHeader: function() {
    if (config.account) {
      $('.header .info .intro').text(config.account);
      $('.header .login_btn').hide();
      $('.header .logout_btn').show();
    } else {
      $('.header .info .intro').text('请先登录');
      $('.header .login_btn').show();
      $('.header .logout_btn').hide();
      
    }
  },
  onLogout: function() {
    requestInterface.logout(function(json) {
      if (json.code == 200) {
        $('#account').html('请先登录');
        $('#server_name').html('');
        $('#role_name').html('');

        config.role_id = '';
        config.account = '';
        awardNum = 0;
        gameNum = 0;
        isBindRole = false;
        bindParams = {};

        obj.updateHeader();
        $('.content-02 .operation .number span').text(0);
        $('.my_prize_popup .list ul').html('');
        localStorage.setItem('access_token', '');
      }
    });
    $('.popup').fadeOut();
  },
}

requestInterface = {
    accountLogin: function(data, callback) {
      const index = layer.load(1);
      $.ajax({
        url: api + "/snail/login/account",
        type: "POST",
        xhrFields: { withCredentials: true },
        data,
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index)
        }
      });
    },
    smsLogin: function(data, callback) {
      const index = layer.load(1);
      $.ajax({
        url: api + '/snail/login/sms',
        type: "POST",
        data,
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
        }
    })
    },
    sendSms: function(phone) {
      const index = layer.load(1);
      $.ajax({
        url: api + '/snail/login/sms/send',
        type: "POST",
        data: { mobile: phone, channel: "login" },
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          } else {
            // 倒计时
            time();
          }
        },
        complete: function() {
          layer.close(index);
        }
      });
    },
    logout: function(callback) {
      const index = layer.load(1);
      $.ajax({
        url: api + "/cherry/draw/logout",
        type: "POST",
        data: { key: activeKey },
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
          } else {
            layer.msg('注销成功');
            $('.prompt-title').fadeOut();
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
        }
      });
    },
    getRoleList: function(data, callback) {
      const index = layer.load(1);
      $.ajax({
        url: api+"/game/server",
        type: "GET",
        xhrFields: { withCredentials: true },
        data,
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
        }
      });
    },
  
    // 业务接口
    init: function(data = {}, callback) {
      data.key = activeKey;
      data.access_token = localStorage.getItem('access_token') || '';
      const index = layer.load(1);
      $.ajax({
        url: api + '/cherry/draw/init',
        type: "GET",
        data,
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
          } else {
            localStorage.setItem('access_token', json.data.activity.access_token);
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
        }
      });
    },
    share: function(data = {}, callback) {
      data.key = activeKey;
      data.access_token = localStorage.getItem('access_token') || '';
      const index = layer.load(1);
      $.ajax({
        url: api + "/cherry/draw/share",
        type: "POST",
        data,
        xhrFields: { withCredentials: true },
        success: function(json) {
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
        }
      });
    },
    lottery: function(data = {}, callback) {
      data.key = activeKey;
      data.access_token = localStorage.getItem('access_token') || '';
      const index = layer.load(1);
      $.ajax({
        url: api + "/cherry/draw/lottery",
        type: "POST",
        data,
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          }
          // {
          //   "code": 200,
          //   "message": "ok",
          //   "data": {
          //     "prize_id": 1,
          //     "is_good": 0
          //   }
          // }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
          $('.prevent-wrap').hide();
        }
      });
    },
    reward: function(data = {}, callback) {
      data.key = activeKey;
      data.access_token = localStorage.getItem('access_token') || '';
      const index = layer.load(1);
      $.ajax({
        url: api + "/cherry/draw/reward",
        type: "POST",
        data,
        xhrFields: { withCredentials: true },
        success: function(json) {
          if (json.code != 200) {
            layer.msg(json.message);
            return false;
          }
          callback && callback(json);
        },
        complete: function() {
          layer.close(index);
          $('.prevent-wrap').hide();
        }
      });
    },
    countNum: function(data) {
      setTimeout(() => {
        try {
          __bl.sum(data);
        } catch (e) {
          console.log(e)
        }
      }, 500);
    }
  };
  
  // 验证码倒计时
  function time() {
    if (wait == 0) {
      $('.obtain-verification label span a').remove();
      $('.obtain-verification label span').html("<a>发送</a>");
      wait = 60;
    } else {
      $('.obtain-verification label span a').remove();
      $('.obtain-verification label span').html("<b>" + wait + "秒</b>");
      wait--;
      timer = setTimeout(function() {
        time()
      }, 1000);
    }
  }
  
  function analysisParams(url) {
    const params = {};
    const paramsString = url.split('?')[1];
    if (!paramsString) {
      return params;
    }
    const str = paramsString.split('&');
    for (let idx = 0; idx < str.length; idx++) {
      const values = str[idx].split('=');
      params[values[0]] = values[1];
    }
    return params;
  };